import { createSlice } from "@reduxjs/toolkit";
import { IWidgetSlice } from "../../../models/master/widgets";


const initialWidgetState: IWidgetSlice = {
  widgets:undefined,
  widget:undefined,
  quickLinkWidget:undefined,
  scholarshipWidget:undefined
};

const widgetSlice = createSlice({
  name: "widget",
  initialState: initialWidgetState,
  reducers: {
    setWidgets: (state, action: { payload: any }) => {
      state.widgets = action.payload;
    },
    setWidget: (state, action: { payload: any }) => {
      state.widget = action.payload;
    },
    setQuickLinksWidget: (state, action: { payload: any }) => {
      state.quickLinkWidget = action.payload;
    },
    setScholarshipWidget: (state, action: {payload: any}) => {
      state.scholarshipWidget = action.payload;
    },
  },
});

export const { setWidgets,setWidget,setQuickLinksWidget,setScholarshipWidget} =
  widgetSlice.actions;

const widgetReducer = widgetSlice.reducer;

export type widgetState = ReturnType<typeof widgetReducer>;

export default widgetReducer;
